import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { inclusionVariants } from "./Inclusion.variants.js";
const Inclusion = ({ icon, labelNode, type = 'included', size = 'sm', actionNode, className, slots = {
    inclusionSlot: '',
    textSlot: '',
    iconSlot: '',
    inclusionIconSlot: ''
}, 'data-testid': dataTestId, ...props })=>{
    const { inclusionSlot, textSlot, iconSlot, inclusionIconSlot } = inclusionVariants({
        ...props,
        size,
        type,
        customIcon: !!icon
    });
    const iconSize = getIconSize(size, !!icon);
    const inclusionIconSize = 'sm' === size ? '10' : '12';
    const inclusionSlotClasses = cn(inclusionSlot(), className ?? slots.inclusionSlot);
    const textSlotClasses = cn(textSlot(), slots.textSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const inclusionIconSlotClasses = cn(inclusionIconSlot(), slots.inclusionIconSlot);
    const iconNode = icon ? /*#__PURE__*/ jsxs("div", {
        className: "flex items-end",
        children: [
            /*#__PURE__*/ jsx(CdnIcon, {
                className: inclusionIconSlotClasses,
                iconName: icon,
                size: iconSize,
                "data-testid": dataTestId
            }),
            /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: getIconName(type, false),
                size: inclusionIconSize,
                "data-testid": getInclusionTestId(type)
            })
        ]
    }) : /*#__PURE__*/ jsx(CdnIcon, {
        className: iconSlotClasses,
        iconName: icon ?? getIconName(type, true),
        size: iconSize,
        "data-testid": getInclusionTestId(type)
    });
    return /*#__PURE__*/ jsxs("div", {
        className: inclusionSlotClasses,
        "aria-label": type,
        children: [
            iconNode,
            labelNode && /*#__PURE__*/ jsx("span", {
                className: textSlotClasses,
                children: labelNode
            }),
            actionNode && /*#__PURE__*/ jsx("div", {
                children: actionNode
            })
        ]
    });
};
function getIconName(inclusionType, isDefaultIcon) {
    if ('included' === inclusionType) return isDefaultIcon ? 'check' : 'check_circle';
    if ('excluded' === inclusionType) return isDefaultIcon ? 'close' : 'cancel';
    if ('unknown' === inclusionType) return isDefaultIcon ? 'question_mark' : 'help';
    return isDefaultIcon ? 'attach_money' : 'paid';
}
function getInclusionTestId(inclusionType) {
    if ('included' === inclusionType) return 'ICON-SUCCESS';
    if ('excluded' === inclusionType) return 'ICON-FAILURE';
    if ('unknown' === inclusionType) return 'ICON-UNKNOWN';
    return 'ICON-FOR-A-FEE';
}
const getIconSize = (size, isCustomIcon)=>{
    if (isCustomIcon) return 'sm' === size ? '20' : '24';
    return 'sm' === size ? '16' : '20';
};
export { Inclusion };
